import { observer } from 'mobx-react-lite';
import { CheckCircle, WarningCircle, Info, X } from '@phosphor-icons/react';
import type { ComponentType } from 'react';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_II18n } from '@/services/i18n/I18n';
import { TOKEN_ToastStore } from './ToastStore';
import type { Toast } from './ToastStore';

const icon: Record<Toast['kind'], ComponentType<{ size?: number; className?: string }>> = {
  success: CheckCircle,
  error: WarningCircle,
  info: Info,
};

const accentClass: Record<Toast['kind'], string> = {
  success: 'text-emerald-700 dark:text-emerald-400',
  error: 'text-accent-strong',
  info: 'text-muted',
};

export const ToastView = observer(function ToastView() {
  const store = useResolve(TOKEN_ToastStore);
  const i18n = useResolve(TOKEN_II18n);
  if (store.toasts.length === 0) return null;
  return (
    <div className="pointer-events-none fixed bottom-5 left-1/2 flex -translate-x-1/2 flex-col gap-2">
      {store.toasts.map((t) => {
        const Icon = icon[t.kind];
        return (
          <div
            key={t.id}
            className="pointer-events-auto flex min-w-[240px] items-center gap-2 rounded-full border border-line bg-surface px-4 py-2 text-sm text-ink shadow-sm"
          >
            <Icon size={18} className={accentClass[t.kind]} />
            <span className="flex-1">{t.message}</span>
            <button
              type="button"
              onClick={() => store.dismiss(t.id)}
              className="text-muted hover:text-ink"
              aria-label={i18n.t('common.close')}
            >
              <X size={14} />
            </button>
          </div>
        );
      })}
    </div>
  );
});
